// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module__header___1F-Rj"};